import { buildProps, definePropType } from '@ll-plus/utils'

import type { ExtractPropTypes } from 'vue'
import type DropdownButtonSimple from './dropdown-button-simple.vue'
import type { IconProps, ButtonProps } from '@ll-plus/components'
import {
  type ButtonProps as AButtonProps,
  type DropdownProps
} from 'ant-design-vue'

export interface DropdownItemProps {
  iconProps?: IconProps
  label?: string
  disabled?: boolean
  key?: string | number
}

export const defaultButtonProps = {
  label: '新增',
  type: 'primary'
}

export const dropdownButtonSimpleProps = buildProps({
  /**
   * 按钮相关配置
   */
  buttonProps: {
    type: definePropType<ButtonProps & AButtonProps>(Object),
    default: () => ({})
  },
  /**
   * 按钮Icon配置
   */
  iconProps: {
    type: definePropType<IconProps>(Object),
    default: () => ({
      iconName: 'icon-add'
    })
  },
  /**
   * 下拉菜单相关配置
   */
  dropDownProps: {
    type: definePropType<DropdownProps>(Object),
    default: () => ({
      trigger: 'click'
    })
  },
  /**
   * 下拉菜单项
   */
  dropdownItems: {
    type: definePropType<DropdownItemProps[]>(Array),
    default: () => []
  },
  /**
   * 是否显示展开状态
   */
  showExpandType: {
    type: Boolean,
    default: true
  },
  /**
   * 总体的启禁用
   */
  disabled: {
    type: Boolean,
    default: false
  }
} as const)

export const dropdownButtonSimpleEmits = {
  clickItem: (item: DropdownItemProps) => !!item
} as const

// props
export type DropdownButtonSimpleProps = ExtractPropTypes<
  typeof dropdownButtonSimpleProps
>

// emits
export type DropdownButtonSimpleEmits = typeof dropdownButtonSimpleEmits

// instance
export type DropdownButtonSimpleInstance = InstanceType<
  typeof DropdownButtonSimple
>
